import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { LocalProjectPreviewInterceptor } from 'core/interceptors/project/local-project-preview.interceptor';
import { ProjectInterceptor } from 'core/interceptors/project/project.interceptor';
import { BannedAccountInterceptor } from 'core/interceptors/token/banned-account.interceptor';
import { RefreshTokenInterceptor } from 'core/interceptors/token/refresh-token.interceptor';
import { DefaultGoodAdditions } from 'project/modules/goods/goods-resolvers';
import { NoticeInfoResolver } from 'project/modules/history/notices-log/notices-log-resolvers';
import { TransactionResolver } from 'project/modules/history/remains-transactions/remains-transactions-resolvers';
import { StatusChangeResolver } from 'project/modules/history/statuses-history/statuses-history-resolvers';
import { RejectedOrdersCountByOrderCountResolver, UnloadingPassResolver, UnloadingResolver } from 'project/modules/history/unloading-history/unloading-history-resolvers';
import { ClaimCountResolver, ClaimResolver } from 'project/modules/reconciliation/claims/claims-resolvers';
import { MonthsDebtsResolver } from 'project/modules/reconciliation/debt/debt-resolvers';
import {
  RoutableQueryBuilderResolver as CourierChainQueryBuilderResolver,
  CourierChainsWithCountsResolver,
} from 'project/modules/settings/courier-chains/courier-chains-resolvers';
import { CourierSettingResolver } from 'project/modules/settings/couriers/couriers-resolvers';
import { SettingsResolver } from 'project/modules/settings/documents/documents-resolvers';
import { ExtensionSettingsResolver } from 'project/modules/settings/extension/extension-resolvers';
import { ScheduledTaskResolver } from 'project/modules/settings/scheduled-tasks/scheduled-tasks-resolvers';
import { DefaultSenderAdditions } from 'project/modules/settings/senders/senders-resolvers';
import { SequencesResolver } from 'project/modules/settings/sequences/sequences-resolvers';
import {
  RoutableQueryBuilderResolver as StatusChainQueryBuilderResolver,
} from 'project/modules/settings/status-chains/status-chains-resolvers';
import { ProjectStateResolver } from 'project/project-route-resolvers';
import { BackgroundTaskRunner } from '../../../shared/common/background-task-runner';
import { AdditionsService } from '../../services/additions.service';
import { BackgroundTaskService } from './background/background-task.service';
import { ChainNoticesService } from './courier/chain-notices.service';
import { CourierService } from './courier/courier.service';
import { CouriersChainService } from './courier/couriers-chain.service';
import { CoverageService } from './courier/coverage.service';
import { TrackReservationService } from './courier/track-reservation.service';
import { UnloadingCheckDialogsService } from './courier/unloading-check-dialogs.service';
import { UnloadingService } from './courier/unloading.service';
import { CurrentProjectService } from './current-project.service';
import { DocumentPoolService } from './document/document-pool.service';
import { DocumentService } from './document/document.service';
import { ExtensionService } from './extension/extension.service';
import { GoodService } from './good/good.service';
import { NoticeService } from './notice/notice.service';
import { NoticesLogService } from './notices-log/notices-log.service';
import { OrderService } from './order/order.service';
import { OrderCodeService } from './orderCodeService';
import { PrintingService } from './printing/printing.service';
import { NoticeResolver } from './project-resolvers';
import { ReconciliationService } from './reconciliation/reconciliation.service';
import { RemainsTransactionsService } from './remains-transactions/remains-transactions.service';
import { ResourceUpdatesService } from './resource-updates/resource-updates.service';
import { OrderFieldMapService } from './rule-set/order-field-map.service';
import { ScheduledTasksService } from './scheduled-tasks/scheduled-tasks.service';
import { SenderService } from './sender/sender.service';
import { SequencesService } from './sequences/sequences.service';
import { StatusChainService } from './status/status-chain.service';
import { StatusService } from './status/status.service';
import { StatusesHistoryService } from './status/statuses-history.service';
import { StorehouseService } from './store-house/storehouse.service';

@NgModule({
  providers: [
    GoodService,
    SenderService,
    DefaultGoodAdditions,
    NoticeInfoResolver,
    TransactionResolver,
    StatusChangeResolver,
    UnloadingResolver,
    UnloadingPassResolver,
    RejectedOrdersCountByOrderCountResolver,
    ClaimCountResolver,
    ClaimResolver,
    MonthsDebtsResolver,
    CourierChainQueryBuilderResolver,
    CourierChainsWithCountsResolver,
    CourierSettingResolver,
    SettingsResolver,
    ExtensionSettingsResolver,
    ScheduledTaskResolver,
    DefaultSenderAdditions,
    SequencesResolver,
    StatusChainQueryBuilderResolver,
    ProjectStateResolver,
    BackgroundTaskService,
    ChainNoticesService,
    CourierService,
    CouriersChainService,
    CoverageService,
    TrackReservationService,
    UnloadingCheckDialogsService,
    UnloadingService,
    CurrentProjectService,
    DocumentPoolService,
    DocumentService,
    ExtensionService,
    NoticeService,
    NoticesLogService,
    OrderService,
    OrderCodeService,
    PrintingService,
    NoticeResolver,
    ReconciliationService,
    RemainsTransactionsService,
    ResourceUpdatesService,
    OrderFieldMapService,
    ScheduledTasksService,
    SequencesService,
    StatusChainService,
    StatusService,
    StatusesHistoryService,
    StorehouseService,
    AdditionsService,
    BackgroundTaskRunner,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BannedAccountInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RefreshTokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ProjectInterceptor,
      multi: true,
    },
    // TODO: Remove the local preview and its fixtures/tests once the backend supplies project data.
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LocalProjectPreviewInterceptor,
      multi: true,
    },
  ],
})
export class ProjectServicesModule {
}
